var img = "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='4' y='3' width='24' height='8' rx='2.66667' fill='%23414141'/%3e%3crect x='2' y='15' width='28' height='1.5' rx='0.75' fill='%23DBDBDB'/%3e%3crect x='4' y='21' width='24' height='8' rx='2.66667' fill='%23414141'/%3e%3c/svg%3e";
  var DividerOutlined = img;

export { DividerOutlined as default };
